// One-shot reload to catch the pending → processing transition, or a cancelled job whose
// log file isn't written to S3 by the remote generator yet at the moment it gets cancelled.
// The WebSocket subscription takes ~1-2s to establish after page load, but the
// first poll fires almost immediately (0s delay), causing the first broadcast to
// be missed. This schedules a single reload 5s after landing on a non-terminal
// show page, giving the server time to have polled and the page to show the
// latest status. sessionStorage prevents the reload from looping.
function scheduleStatusRefresh() {
  const el = document.querySelector('[data-pc-status-refresh]');
  if (!el) return;

  const pcId = el.dataset.pcStatusRefresh;
  const key = `pc_status_refreshed_${pcId}`;

  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');

  setTimeout(function () {
    if (document.querySelector('[data-pc-status-refresh]')) {
      Turbo.visit(window.location.href, { action: 'replace' });
    }
  }, 5000);
}

document.addEventListener('turbo:load', scheduleStatusRefresh);

// Cancelling from the show page updates it in place via turbo_stream (no turbo:load fires),
// so also check once the stream has finished rendering.
document.addEventListener('turbo:before-stream-render', (event) => {
  const originalRender = event.detail.render;
  event.detail.render = async (streamElement) => {
    await originalRender(streamElement);
    scheduleStatusRefresh();
  };
});
